module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAARCAYAAAA7bUf6AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAEcSURBVDhPrVSxTsMwFIz4oioOUvmEsPENxaGCpaXqUKlS/wIBEjv8REe+gYUFiaEdYajo8I53jhPh1Cmp1JNOlv3unpyznaQJLBYnkhYjMfZVTLGS1G7dyLmus+6lcUjP5ir8ginQRtalN8y9JYSkw0nM1EbqvbWEZDaPCf8jfa6Bz2DvJ7RR8/p2GUmmYUUEXUl/wtRjxa6kn01WsWJX6vGv9VTsNlbsSvqPtJOjZNI8nckdML0PhDWnD8D8KVjTJuPde3J2A7x/Ai9L4GIO9K/L8VnnXGe9alDdE0LM4LxuQmbK2SPw9gFsfsqRc67/0dHnGlSQ0wPfjuq9NQTfgqa9/xVrXcxVuIMmXEYalgob/xPOL2/rDGokyS+fUHuQiZA4cgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./app/img/8.png
// module id = 87
// module chunks = 0